import {CalendarDay, CalendarItem} from './calendar.model';

function startOfMonth(date: Date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}

function endOfMonth(date: Date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

export function buildMonthGrid(seedDate: Date, weekStartsOn = 1): CalendarDay[] {
    // Начало недели: weekStartsOn: 0 = Воскресенье, 1 = Понедельник (default)
    const start = startOfMonth(seedDate);
    const end = endOfMonth(seedDate);

    const startDayIndex = (start.getDay() - weekStartsOn + 7) % 7;
    const totalDays = end.getDate();

    const grid: CalendarDay[] = [];

    // Дни предыдущего месяца для полноты сетки
    for (let i = 0; i < startDayIndex; i++) {
        const d = new Date(start);
        d.setDate(d.getDate() - (startDayIndex - i));
        grid.push({date: d, inMonth: false, items: [], extra: 0, visibleItems: []});
    }

    for (let d = 1; d <= totalDays; d++) {
        const date = new Date(start.getFullYear(), start.getMonth(), d);
        grid.push({date, inMonth: true, items: [], extra: 0, visibleItems: []});
    }

    // Заполнение сетки до конца следующим месяцем
    while (grid.length % 7 !== 0) {
        const last = grid[grid.length - 1].date;
        const d = new Date(last);
        d.setDate(d.getDate() + 1);
        grid.push({date: d, inMonth: false, items: [], extra: 0, visibleItems: []});
    }

    return grid;
}

export function buildItemsMap(
    items: (CalendarItem & { __key: string })[],
    prevMap: Record<string, CalendarItem[]>
) {
    //TODO продумать смысл обработки всех итемов или только показывающиеся
    const map: Record<string, CalendarItem[]> = Object.create(null);
    let changed = false;

    for (const it of items) {
        const key = it.__key;
        if (!map[key]) {
            map[key] = [];
        }
        const {__key, ...clean} = it;
        map[key].push(clean as CalendarItem);
    }

    if (!prevMap) {
        return map;
    }

    const prevKeys = Object.keys(prevMap);
    const newKeys = Object.keys(map);

    if (prevKeys.length !== newKeys.length) {
        return map;
    }

    for (const key of newKeys) {
        const prevArr = prevMap[key];
        const newArr = map[key];

        if (!prevArr) {
            changed = true;
            continue;
        }

        if (prevArr.length !== newArr.length) {
            changed = true;
            continue;
        }

        let same = true;
        for (let i = 0; i < prevArr.length; i++) {
            if (prevArr[i].id !== newArr[i].id) {
                same = false;
                break;
            }
        }

        if (same) {
            map[key] = prevArr;
        } else {
            changed = true;
        }
    }

    return changed ? map : prevMap;
}

